import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { waterfallFlowsActions } from 'features/waterfallFlows';

const useWaterfallFlows = () => {
  const dispatch = useDispatch();
  const getWaterfallFlow = useCallback(() => dispatch(waterfallFlowsActions.getWaterfallFlow()), [dispatch]);
  const createWaterfallFlow = useCallback(waterfall_flow => dispatch(waterfallFlowsActions.createWaterfallFlow(waterfall_flow)), [dispatch]);
  const updateWaterfallFlow = useCallback(waterfall_flow => dispatch(waterfallFlowsActions.updateWaterfallFlow(waterfall_flow)), [dispatch]);
  const deleteWaterfallFlow = useCallback(() => dispatch(waterfallFlowsActions.deleteWaterfallFlow()), [dispatch]);
  const clearLocalActiveWaterfallFlow = useCallback(() => dispatch(waterfallFlowsActions.clearLocalActiveWaterfallFlow()), [dispatch]);

  return {
    getWaterfallFlow,
    createWaterfallFlow,
    updateWaterfallFlow,
    deleteWaterfallFlow,
    clearLocalActiveWaterfallFlow
  };
};

export default useWaterfallFlows;